import { bg_button, bg_text } from "constant/css";
import React, { useState } from "react";

const EyeCursor = ({ rotation, onClick, visible }) => {
  return (
    <div
      className={`${bg_button} ${visible ? "eye_closed" : "eye"}`}
      onClick={onClick}
      style={{
        width: "30px",
        // Change height to simulate closing the eye
        backgroundColor: `#9cd9c7`,
        borderRadius: "50%",
        transform: `rotate(${rotation}deg)`,
        transition: "transform 0.1s ease-out, height 0.1s ease-out",
      }}
    />
  );
};

export default EyeCursor;
